/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Cod_Override_Freight_Already_AddedInputs */

const vi_carrier_form_cod_override_freight_already_added = /** @type {(inputs: Carrier_Form_Cod_Override_Freight_Already_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không cần tự cộng cước, Viettel Post sẽ cộng cước khi thu.`)
};

/**

* @param {Carrier_Form_Cod_Override_Freight_Already_AddedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override_freight_already_added = /** @type {((inputs?: Carrier_Form_Cod_Override_Freight_Already_AddedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Override_Freight_Already_AddedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override_freight_already_added(inputs)
});